import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { RoadTypesFailure, RoadTypesRequest, RoadTypesSuccess } from './actions';
import { RoadTypesService } from './service';
import { AppState } from '@store/app.state';
import { select, Store } from '@ngrx/store';
import { getData } from './selectors';

@Injectable()
export class RoadTypesEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store<AppState>);
  private readonly roadTypesService = inject(RoadTypesService);

  roadTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoadTypesRequest),
      withLatestFrom(this.store.pipe(select(getData))),
      switchMap(([{ parameters }, data]) => {
        if (!data?.length) {
          return this.roadTypesService.roadTypes(parameters).pipe(
            map(data => RoadTypesSuccess({ data })),
            catchError(error => of(RoadTypesFailure({ error })))
          );
        }
        return of(RoadTypesSuccess({ data }));
      })
    )
  );

}
